import Layout from '../components/layout/Layout'
import Download from '../components/Download/Download'

const DownloadPage = () => {

  return (
    <Layout>
      <Download />
    </Layout>
  )
}

export default DownloadPage